﻿import { apiClient } from '@api/apiClient';
import { RoutingFlagDto } from '@store/routingFlag/types';

export const fetchRoutingFlags = async () => {
  const response = await apiClient.get('/featureflag/routingflags');
  if ('value' in response) {
    return response.value as RoutingFlagDto[];
  }
  return undefined;
};
